<script lang="ts" context="module">
  export type CheckboxOption = {
    value: string;
    disabled: boolean;
  };
</script>

<script lang="ts">
  import { getContext, onMount, createEventDispatcher } from "svelte";
  import WrapField from "./WrapField.svelte";
  import type { createFormStore } from "$components/form/store";

  export let label: string;
  export let name: string;
  export let value: string[] = [];
  export let options: CheckboxOption[] = [];
  export let validationRules: { [key: string]: any } = {};

  let refs: HTMLInputElement[] = [];

  const dispatch = createEventDispatcher();
  const formStore: ReturnType<typeof createFormStore> | undefined = getContext("form");
  const twInputClasses = [
    "disabled:opacity-30",
    "cursor-pointer rounded border-gray-400 dark:bg-transparent",
    "checked:border-transparent dark:checked:border-transparent",
    "checked:bg-brand-blurple dark:checked:bg-brand-blurple checked:hover:bg-brand-blurple/80 dark:checked:hover:bg-brand-blurple/80",
    "dark:hover:border-brand-blurple dark:focus:border-gray-300",
    "hover:border-brand-blurple text-gray-800",
    "focus:ring-transparent focus:ring-offset-transparent dark:border-gray-200 dark:border-gray-400 focus:checked:bg-brand-blurple",
  ].join(" ");

  function onSelect() {
    if (formStore) {
      formStore.setField(name, value);
    } else if (value) {
      dispatch("change", value);
    }
  }

  onMount(() => {
    if (formStore) {
      formStore.addRef(name, refs);
      value = $formStore?.values[name];
    }
  });
</script>

<WrapField
  {label}
  {name}
  inputWrapperClass="basis-1/4 shrink-0"
  wrapperClassname="mb-[12px] flex-row justify-between"
  {validationRules}
>
  <div class="flex justify-around">
    {#each options as option, i}
      <div class="flex w-[30px] items-center justify-center">
        <input
          type="checkbox"
          name="selected"
          value={option.value}
          class={twInputClasses}
          disabled={option.disabled}
          bind:this={refs[i]}
          bind:group={value}
          on:change={onSelect}
        />
      </div>
    {/each}
  </div>
</WrapField>
